// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"389":"c7c5d793","631":"31bf1487","825":"fa721862"}[chunkId] + ".css";
};